module.exports = __webpack_public_path__ + "media/images/paper-bg-8d7d46ebf7dcab73e4dab419d80382e9.png";